<template>
  <div>
    <div class="is-flex is-justify-content-space-between">
      <div v-if="position" class="editor">
        <div style="margin-top: 0;">
          <p>כותרת המשרה</p>
          <input v-model="title" class="outlined full_width">
        </div>
        <div>
          <p>תיאור התפקיד</p>
          <textarea v-model="description" placeholder='משרד עו"ד מוביל בחיפה מחפש עו"ד לתחום דיני משפחה וירושה למשרה מלאה.'></textarea>
        </div>
        <div>
          <p>{{ work_entails_title }}</p>
          <textarea v-model="work_entails"></textarea>
        </div>
        <div>
          <p>{{ requirements_title }}</p>
          <textarea v-model="requirements"></textarea>
        </div>
        <div>
          <p>{{ personal_requirements_title }}</p>
          <textarea v-model="personal_requirements"></textarea>
        </div>
        <div>
          <p>האשטגים</p>
          <textarea v-model="hashtags" class="outlined"></textarea>
        </div>
        <!-- Text Fields for all operations -->
        <div>
          <div>
            <p>כותרת ראשונה (תוצג על התמונה)</p>
            <input v-model="text1" class="outlined full_width">
          </div>
          <div>
            <p>כותרת שנייה (תוצג על התמונה)</p>
            <input v-model="text2" class="outlined full_width" placeholder="כותרת 2">
          </div>
        </div>
      </div>
      <div class="left_column">
        <div v-if="position" id="preview">
          <div class="preview_text_container">
            <div>
              <p>
                {{ operationIcon }} {{ title }} {{ operationIcon }}
                <br>
                <span v-html="formatText(description)"></span>
              </p>
            </div>
            <div v-if="work_entails.length > 0">
              <p class="work_entails">
                {{ work_entails_title }}
                <br>
                <span v-html="formatText(work_entails)"></span>
              </p>
            </div>
            <div v-if="requirements.length > 0">
              <p>
                {{ requirements_title }}
                <br>
                <span v-html="formatText(requirements)"></span>
              </p>
            </div>
            <div v-if="personal_requirements.length > 0">
              <p>
                {{ personal_requirements_title }}
                <br>
                <span v-html="formatText(personal_requirements)"></span>
              </p>
            </div>
            <component :is="footer" :position="position" :position_link="getPositionLink"></component>
            <div>
              <p>{{ getHashtags }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="is-flex is-justify-content-center">
      <div class="content_maker_container">
        <div class="is-flex is-align-items-center is-justify-content-space-between full_width">
          <p>מחולל תמונות</p>
          <input @change="setPhotoMakerPicture" type="file" accept="image/*" style="width: 94px; font-size: 12px;">
        </div>
        <checkbox v-model="show_instagram_frame">Show Instagram Frame</checkbox>

        <!-- Category Selection and Random Image Picker -->
        <div v-if="imageCategories.length > 0" class="box mt-4">
          <h5 class="mb-2">בחירת תמונה מקטגוריה</h5>
          <div class="is-flex is-align-items-center" style="gap: 10px;">
            <div class="select" style="flex: 1;">
              <select v-model="selectedCategory" class="full_width">
                <option value="">בחר קטגוריה</option>
                <option v-for="category in imageCategories" :key="category" :value="category">
                  {{ category }}
                </option>
              </select>
            </div>
            <button
              @click="selectRandomImage"
              :disabled="!selectedCategory"
              class="button is-info"
            >
              בחר רנדומלית
            </button>
          </div>
        </div>

        <!-- AI Image Generator Section -->
        <div class="box mt-4">
          <ImageGenerator
            :prompt="imagePrompt"
            buttonText="יצירת תמונה לפוסט"
            :disabled="true"
            @image-generated="onImageGenerated"
            @image-cleared="onImageCleared"
          />
        </div>

        <!-- Save Image Button (only for Rebase) -->
        <div v-if="selected_picture && isRebase()" class="mt-3 mb-3">
          <button
            @click="savePostImage"
            :disabled="isSavingImage"
            class="button is-success"
          >
            {{ isSavingImage ? 'שומר...' : 'שמור תמונה' }}
          </button>
        </div>

        <!-- Saved Images List (only for Rebase) -->
        <div v-if="isRebase()" class="saved-images-section mt-4">
          <h4>תמונות שמורות</h4>
          <div v-if="isLoadingImages" class="loading">טוען תמונות...</div>
          <div v-else-if="savedImages.length === 0" class="no-images">אין תמונות שמורות</div>
          <div v-else class="saved-images-grid">
            <div v-for="image in savedImages" :key="image.filename" class="saved-image-item">
              <img :src="image.url" :alt="image.filename" class="saved-image-thumbnail" @click="loadSavedImage(image.url)">
              <div class="saved-image-actions">
                <button @click="loadSavedImage(image.url)" class="button is-small is-info">טען</button>
                <button @click="deleteSavedImage(image.filename)" class="button is-small is-danger">מחק</button>
              </div>
              <div class="saved-image-filename">{{ image.filename }}</div>
            </div>
          </div>
        </div>

        <div v-if="selected_picture">
          <!-- Unified Template for all operations -->
          <div v-if="show_instagram_frame == false" id="content_maker" dir="rtl" @click="selectRandomImage" style="cursor: pointer;" title="לחץ על התמונה להחלפה רנדומלית">
            <img class="content_maker_image" :src="selected_picture">
            <div class="content_maker_opacity" style="pointer-events: none;"></div>

            <!-- Stars background for Suitup only -->
            <img v-if="getOperation === 'Suitup'" class="content_maker_stars" src="/suitup_background_theme.png" style="pointer-events: none;">

            <div class="unified_content" style="pointer-events: none;">
              <p style="font-size: 50px; pointer-events: auto;" contenteditable="true" @click.stop>{{ text1 }}</p>
              <p style="font-size: 50px; pointer-events: auto;" contenteditable="true" @click.stop>{{ text2 }}</p>
            </div>

            <div class="content_maker_logo_container" :style="getLogoContainerStyle()">
              <p v-if="getPhoneNumber()" class="footer_phone" :style="getPhoneStyle()">{{ getPhoneNumber() }}</p>
              <div v-if="getPhoneNumber()" class="footer_divider"></div>
              <p v-if="getLogoTagline()" class="logo_tagline" :class="{ 'logo_tagline_piola': getOperation === 'Piola' }" :style="getLogoTaglineStyle()">{{ getLogoTagline() }}</p>
              <div v-if="getLogoTagline()" class="footer_divider"></div>
              <img :style="getLogoImageStyle()" :src="$settings.get({ path: 'images' }).logo_bright">
            </div>
          </div>

          <div v-if="show_instagram_frame == true" class="relative is-flex is-align-items-center is-justify-content-center" style="margin-top: 20px;" @click="selectRandomImage" title="לחץ על התמונה להחלפה רנדומלית">
            <img src="/logo_instagram_frame.png" class="content_maker_image instagram_frame_image" style="z-index: 1000000; pointer-events: none;">
            <img src="/instagram_frame.png" class="content_maker_image" style="pointer-events: none;">
            <div class="content_maker_opacity" style="pointer-events: none;"></div>
            <div contenteditable="true" class="content_maker_input" style="z-index: 100000000; pointer-events: auto; cursor: text;"></div>
            <img :src="selected_picture" class="content_maker_image instagram_frame_image" style="cursor: pointer;">
          </div>
        </div>

        <!-- Image Download Button -->
        <div v-if="selected_picture" class="mt-3 mb-3 is-flex is-justify-content-center">
          <button
            @click="downloadImage"
            :disabled="isGeneratingImage"
            class="button is-primary"
          >
            {{ isGeneratingImage ? 'מכין תמונה...' : 'הורד כתמונה' }}
          </button>
        </div>
      </div>
    </div>
    <div class="vertical_space"></div>
    <div class="vertical_space"></div>
    <div class="vertical_space"></div>
    <div class="modal_footer">
      <a
        @click="copyWithImage()"
        class="button is-info"
        >Copy</a
      >
    </div>
  </div>
</template>
<script>
import TextsHelper from '@/custom/classes/texts_helper.js'
import QuestionsHelper from '@/custom/classes/questions_helper.js'
import Seniority from '@/custom/classes/seniority.js'
import Checkbox from '@/components/Checkbox'
import ImageGenerator from '@/components/ImageGenerator'
import SuitupFooter from '@/components/position_post_forms/SuitupFooter'
import OfficeFooter from '@/components/position_post_forms/OfficeFooter'
import RebaseFooter from '@/components/position_post_forms/RebaseFooter'
import PiolaFooter from '@/components/position_post_forms/PiolaFooter'
export default {
  name: 'create-position-post-form',
  props: ['payload'],
  data () {
    return {
      questions_helper: new QuestionsHelper(),
      texts_helper: new TextsHelper(),
      seniority: new Seniority(),
      position: undefined,
      texts: [],
      title: '',
      description: '',
      work_entails: '',
      requirements: '',
      personal_requirements: '',
      operationIcon: this.$settings.get({ path: 'icon' }),
      operation_name: this.$settings.get({ path: 'operation_name' }),
      hashtags: this.$settings.get({ path: 'hashtags' }),
      footer: this.$settings.get({ path: 'operation_name' }) + 'Footer',
      selected_picture: undefined,
      show_instagram_frame: false,
      positionsSkills: [],
      savedImages: [],
      isLoadingImages: false,
      isSavingImage: false,
      isGeneratingImage: false,
      text1: '',
      text2: '',
      imageCategories: [],
      selectedCategory: '',
      categoryImages: []
    }
  },
  computed: {
    work_entails_title () {
      return this.operationIcon + ' התפקיד כולל:'
    },
    requirements_title () {
      return this.operationIcon + ' דרישות התפקיד:'
    },
    personal_requirements_title () {
      return this.operationIcon + ' דרישות אישיות:'
    },
    getOperation () {
      return this.$settings.get({ path: 'operation_name' })
    },
    getPositionLink () {
      if (this.position == undefined) {
        return
      }
      let operation_first_char = this.$settings.get({ path: 'operation_name' }).charAt(0).toUpperCase()
      let position_applicant_code = this.$utils.getPositionApplicantCode(this.position.id).replace(operation_first_char + '-', '')
      return `${this.$settings.get({ path: 'links' }).website_url}${this.$settings.get({ path: 'seo_single_position_path' })}/${position_applicant_code}`
    },
    getHashtags () {
      if (this.hashtags.length == 0) {
        return
      }
      let splitted = this.hashtags.split('\n')
      for (let i = 0; i < splitted.length; i++) {
        splitted[i] = '#' + splitted[i]
      }
      return splitted.join('\n')
    },
    imagePrompt () {
      if (!this.positionsSkills || this.positionsSkills.length === 0) {
        return ''
      }

      const skills = this.positionsSkills.map(skill => skill.name).join(', ')
      return `Create a colorful, abstract visual representation of professional skills: ${skills}. Use vibrant colors, geometric shapes, icons and symbols. No text, letters, or words should appear in the image. Style: modern, professional, suitable for social media post.`
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      let position_request = this.$network_utils.getPosition({ id: this.payload.position_id })
      let texts_request = this.$network_utils.getResourceTexts({ current_resource_id: this.payload.position_id, current_type: 'Position' })
      let questions_request = this.$network_utils.getResourceQuestions({
        current_resource_id: this.payload.position_id,
        current_type: 'Position',
        designators: 'seniority'
      })
      let requests = [position_request, texts_request, questions_request]
      this.$caller.axios.all(requests).then(response => {
        this.position = response[0]
        this.texts = response[1]
        this.questions = response[2]
        this.title = this.position.title
        this.work_entails = this.getWorkEntails()
        this.requirements = this.getRequirements()
        this.extractPositionSkills()
        this.text1 = this.position.title
        this.text2 = 'כותרת 2'
        if (this.isRebase()) {
          this.loadSavedImages()
        }
        this.loadImageCategories()
      })
    },
    async loadImageCategories () {
      try {
        const response = await this.$network_utils.getPublicImageCategories()
        this.imageCategories = response.categories || []
      } catch (error) {
        console.error('Error loading image categories:', error)
        this.imageCategories = []
        this.$toast.error('שגיאה בטעינת קטגוריות תמונות')
      }
    },
    async selectRandomImage () {
      if (!this.selectedCategory) {
        this.$toast.error('יש לבחור קטגוריה תחילה')
        return
      }

      try {
        const dataUrl = await this.$network_utils.getRandomPublicImage({ category: this.selectedCategory })
        if (dataUrl) {
          // The response is now a data URL (base64 encoded image)
          this.selected_picture = dataUrl
          this.$toast.success('תמונה נבחרה באופן אקראי')
        } else {
          this.$toast.warning('לא נמצאה תמונה בקטגוריה זו')
        }
      } catch (error) {
        console.error('Error selecting random image:', error)
        this.$toast.error('שגיאה בבחירת תמונה אקראית')
      }
    },
    getWorkEntails () {
      let work_entails_text = this.texts_helper.getTextByDesignator(this.texts, 'work_entails')
      let work_entails_content = this.texts_helper.getContent(work_entails_text)
      return work_entails_content.split('@@@').join('\n')
    },
    getRequirements () {
      let seniority_question = this.questions_helper.getQuestionByDesignator(this.questions, 'seniority')
      let answers_option_ids = this.questions_helper.getAnsweredOptionIdsFromQuestion(seniority_question)
      let answers = seniority_question.options.filter(option => answers_option_ids.includes(option.id)).map(option => option.text)
      if (!answers.reduce((acc, curr) => acc && /^[0-9]*$/.test(curr), true)) {
        return ''
      }
      let seniority = this.seniority.getDisplayText(answers).years
      let seniority_text = (seniority == '1' ? 'שנת' : seniority + ' שנות') + ' ותק'
      return seniority_text
    },
    formatText (text) {
      return text.replace(/\n/g, '<br>')
    },
    copy () {
      this.$utils.copyToClipboardFromElement('preview')
    },
    async copyWithImage () {
      if (this.selected_picture) {
        // Copy the visual post with image
        try {
          const canvas = await this.captureContentMaker()

          // Copy canvas to clipboard as image
          canvas.toBlob(async (blob) => {
            try {
              await navigator.clipboard.write([
                // eslint-disable-next-line no-undef
                new ClipboardItem({
                  'image/png': blob
                })
              ])
              this.$toast.success('הפוסט הועתק בהצלחה')
            } catch (error) {
              console.error('Error copying image to clipboard:', error)
              this.copy() // Fallback to text copy
            }
          }, 'image/png')
        } catch (error) {
          console.error('Error capturing image:', error)
          this.copy() // Fallback to text copy
        }
      } else {
        // When no image, copy text
        this.copy()
      }
    },
    updateTitle (event) {
      this.title = event.target.innerText
    },
    updateDescription (event) {
      this.description = event.target.innerText
    },
    updateWorkEntails (event) {
      this.work_entails = event.target.innerText
    },
    updateRequirements (event) {
      this.requirements = event.target.innerText
    },
    updateHashtags (event) {
      const text = event.target.innerText
      // Remove # symbols and convert to proper hashtag format
      this.hashtags = text.split('\n').map(line => line.replace(/^#/, '')).join('\n')
    },
    getLogoTagline () {
      if (this.getOperation == 'Suitup') {
        return 'השמת עו"ד ויועצים משפטיים'
      }
      if (this.getOperation == 'Piola') {
        return '  השמה בעולם האדמיניסטרציה והכספים'
      }
      if (this.getOperation == 'Rebase') {
        return 'גיוס והשמה בענף הבניין'
      }
    },
    getLogoContainerStyle () {
      if (this.getOperation === 'Piola') {
        return {
          zIndex: 1000000,
          position: 'absolute',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '4px',
          padding: '0 20px',
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(35, 6, 69, 0.8)',
          height: '70px'
        }
      } else if (this.getOperation === 'Rebase') {
        return {
          zIndex: 1000000,
          position: 'absolute',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'baseline',
          gap: '0px',
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(91, 75, 75, 0.8)',
          height: 'auto',
          paddingTop: '10px',
          paddingBottom: '10px',
          paddingLeft: '5px',
          paddingRight: '5px'
        }
      } else {
        return {
          zIndex: 1000000,
          position: 'absolute',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '8px',
          padding: '0 20px',
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(91, 75, 75, 0.8)',
          height: '80px'
        }
      }
    },
    getLogoTaglineStyle () {
      if (this.getOperation === 'Rebase') {
        return {
          fontSize: '40px',
          marginLeft: '3px',
          marginRight: '10px',
          marginBottom: '6px',
          fontWeight: '500',
          lineHeight: '1',
          display: 'inline-flex',
          alignItems: 'center'
        }
      }
      if (this.getOperation === 'Suitup') {
        return {
          marginTop: '10px',
          display: 'inline-flex',
          alignItems: 'center',
          lineHeight: '1'
        }
      }
      if (this.getOperation === 'Piola') {
        return {
          fontSize: '32px',
          padding: '0 8px',
          gap: '8px',
          display: 'inline-flex',
          alignItems: 'center',
          lineHeight: '1'
        }
      }
      return {
        display: 'inline-flex',
        alignItems: 'center',
        lineHeight: '1'
      }
    },
    getLogoImageStyle () {
      if (this.getOperation === 'Rebase') {
        return {
          width: '180px',
          marginBottom: '2px',
          marginLeft: '4px',
          display: 'block'
        }
      }
      if (this.getOperation === 'Piola') {
        return {
          width: '150px',
          maxWidth: 'none',
          marginRight: '-20px',
          display: 'block'
        }
      }
      return {
        width: '120px',
        display: 'block',
        marginTop: '1px'
      }
    },
    getPhoneNumber () {
      if (this.getOperation === 'Suitup') {
        return '03-7767762'
      }
      if (this.getOperation === 'Piola') {
        return '03-5755026'
      }
      if (this.getOperation === 'Rebase') {
        return '03-5535344'
      }
      return null
    },
    getPhoneStyle () {
      if (this.getOperation === 'Piola') {
        return {
          margin: '0',
          fontSize: '38px',
          fontWeight: '500',
          textAlign: 'center',
          lineHeight: '1',
          display: 'flex',
          alignItems: 'center'
        }
      }
      if (this.getOperation === 'Rebase') {
        return {
          margin: '0',
          marginBottom: '6px',
          fontSize: '48px',
          fontWeight: '500',
          textAlign: 'center',
          lineHeight: '1'
        }
      }
      return {
        margin: '0',
        marginTop: '8px',
        fontSize: '44px',
        fontWeight: '500',
        textAlign: 'center',
        lineHeight: '1',
        display: 'flex',
        alignItems: 'center'
      }
    },
    isRebase () {
      return this.getOperation == 'Rebase'
    },
    setPhotoMakerPicture (event) {
      let reader = new FileReader()
      reader.onload = (event) => {
        this.selected_picture = event.target.result
      }
      reader.readAsDataURL(event.target.files[0])
    },
    onImageGenerated (imageUrl) {
      this.selected_picture = imageUrl
    },
    onImageCleared () {
      this.selected_picture = undefined
    },
    extractPositionSkills () {
      if (this.position && this.position.positions_skills) {
        this.positionsSkills = this.position.positions_skills.map(positionSkill => ({
          id: positionSkill.skill.id,
          name: positionSkill.skill.name
        }))
      } else {
        this.positionsSkills = []
      }
    },
    async savePostImage () {
      if (!this.selected_picture || !this.position) {
        this.$toast.error('אין תמונה לשמירה')
        return
      }

      this.isSavingImage = true
      try {
        const canvas = await this.captureContentMaker()

        // Convert canvas to blob
        const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'))

        // Create FormData
        const formData = new FormData()
        formData.append('image', blob, `post_image_${Date.now()}.png`)

        // Send to rebase server
        await this.$network_utils.postPositionPostImage({
          position_id: this.position.id,
          form_data: formData
        })

        this.$toast.success('התמונה נשמרה בהצלחה')
        this.loadSavedImages() // Refresh the list

        // Close the image panel and return to modal
        this.selected_picture = undefined
      } catch (error) {
        console.error('Error saving image:', error)
        this.$toast.error('שגיאה בשמירת התמונה')
      } finally {
        this.isSavingImage = false
      }
    },
    async loadSavedImages () {
      if (!this.position) return

      this.isLoadingImages = true
      try {
        const response = await this.$network_utils.getPositionPostImages({
          position_id: this.position.id
        })
        this.savedImages = response || []
      } catch (error) {
        console.error('Error loading saved images:', error)
        this.savedImages = []
      } finally {
        this.isLoadingImages = false
      }
    },
    loadSavedImage (imageUrl) {
      this.selected_picture = imageUrl
    },
    async deleteSavedImage (filename) {
      if (!confirm('האם אתה בטוח שברצונך למחוק את התמונה?')) {
        return
      }

      try {
        await this.$network_utils.deletePositionPostImage({
          position_id: this.position.id,
          filename: filename
        })
        this.$toast.success('התמונה נמחקה בהצלחה')
        this.loadSavedImages() // Refresh the list
      } catch (error) {
        console.error('Error deleting image:', error)
        this.$toast.error('שגיאה במחיקת התמונה')
      }
    },
    async convertSvgToDataUrl (svgUrl) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.crossOrigin = 'anonymous'

        img.onload = () => {
          const canvas = document.createElement('canvas')
          // Use naturalWidth/naturalHeight for actual SVG dimensions
          // If not available, fall back to rendered size or default
          const width = img.naturalWidth || img.width || 300
          const height = img.naturalHeight || img.height || 100

          canvas.width = width
          canvas.height = height

          const ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0, width, height)

          resolve(canvas.toDataURL('image/png'))
        }

        img.onerror = () => {
          console.warn('Failed to convert SVG to data URL, will use original')
          resolve(svgUrl) // Fallback to original
        }

        img.src = svgUrl
      })
    },
    loadImageForCanvas (src) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.crossOrigin = 'anonymous'
        img.onload = () => resolve(img)
        img.onerror = () => reject(new Error('Failed to load: ' + src))
        img.src = src
      })
    },
    drawImageCover (ctx, img, x, y, w, h) {
      const imgRatio = img.naturalWidth / img.naturalHeight
      const targetRatio = w / h
      let sx, sy, sw, sh
      if (imgRatio > targetRatio) {
        sh = img.naturalHeight
        sw = sh * targetRatio
        sx = (img.naturalWidth - sw) / 2
        sy = 0
      } else {
        sw = img.naturalWidth
        sh = sw / targetRatio
        sx = 0
        sy = (img.naturalHeight - sh) / 2
      }
      ctx.drawImage(img, sx, sy, sw, sh, x, y, w, h)
    },
    async captureContentMaker () {
      const element = this.show_instagram_frame
        ? document.querySelector('.relative.is-flex.is-align-items-center.is-justify-content-center')
        : document.getElementById('content_maker')
      if (!element) throw new Error('לא נמצא אלמנט לצילום')

      const width = element.offsetWidth
      const height = element.offsetHeight
      const containerRect = element.getBoundingClientRect()
      const canvas = document.createElement('canvas')
      canvas.width = width
      canvas.height = height
      const ctx = canvas.getContext('2d')

      // 1. Background image (object-fit: cover)
      const bgImg = await this.loadImageForCanvas(this.selected_picture)
      this.drawImageCover(ctx, bgImg, 0, 0, width, height)

      // 2. Dark overlay
      const opacityEl = element.querySelector('.content_maker_opacity')
      if (opacityEl) {
        ctx.fillStyle = window.getComputedStyle(opacityEl).backgroundColor
        ctx.fillRect(0, 0, width, height)
      }

      // 3. Suitup stars
      const starsEl = element.querySelector('.content_maker_stars')
      if (starsEl) {
        try {
          const starsImg = await this.loadImageForCanvas(starsEl.src)
          ctx.globalAlpha = parseFloat(window.getComputedStyle(starsEl).opacity) || 0.51
          this.drawImageCover(ctx, starsImg, 0, 0, width, height)
          ctx.globalAlpha = 1.0
        } catch (e) { /* stars optional */ }
      }

      // 4. Text overlays - read directly from DOM (handles contenteditable edits)
      const textPs = element.querySelectorAll('.unified_content p')
      textPs.forEach(p => {
        const text = p.textContent.trim()
        if (!text) return
        const pRect = p.getBoundingClientRect()
        const style = window.getComputedStyle(p)
        ctx.fillStyle = style.color
        ctx.font = style.fontStyle + ' ' + style.fontWeight + ' ' + style.fontSize + ' ' + style.fontFamily
        ctx.textAlign = 'center'
        ctx.textBaseline = 'top'
        ctx.direction = 'rtl'
        const x = (pRect.left - containerRect.left) + pRect.width / 2
        const y = pRect.top - containerRect.top
        ctx.fillText(text, x, y)
      })

      // 5. Footer bar
      const footer = element.querySelector('.content_maker_logo_container')
      if (footer) {
        const footerRect = footer.getBoundingClientRect()
        const footerStyle = window.getComputedStyle(footer)
        const fx = footerRect.left - containerRect.left
        const fy = footerRect.top - containerRect.top
        const fw = footerRect.width
        const fh = footerRect.height

        // Footer background
        ctx.fillStyle = footerStyle.backgroundColor
        ctx.fillRect(fx, fy, fw, fh)

        // Check if tagline pseudo-element separators are hidden (e.g. Rebase)
        const taglineEl = footer.querySelector('.logo_tagline')
        const needsDividers = !taglineEl || window.getComputedStyle(taglineEl, '::before').display === 'none'

        // Draw each footer child at its exact browser position
        for (const child of footer.children) {
          const childStyle = window.getComputedStyle(child)

          // Draw divider only between phone and tagline when pseudo-element separators are hidden
          if (child.classList.contains('footer_divider') && needsDividers) {
            const prev = child.previousElementSibling
            const next = child.nextElementSibling
            const isBetweenPhoneAndTagline = prev && next &&
              ((prev.classList.contains('footer_phone') && next.classList.contains('logo_tagline')) ||
               (prev.classList.contains('logo_tagline') && next.classList.contains('footer_phone')))
            if (isBetweenPhoneAndTagline) {
              const prevRect = prev.getBoundingClientRect()
              const nextRect = next.getBoundingClientRect()
              // Account for padding so divider centers between visible text edges
              const prevStyle = window.getComputedStyle(prev)
              const nextStyle = window.getComputedStyle(next)
              let gapMidX
              if (nextRect.left < prevRect.left) {
                // next is to the left of prev (RTL: tagline left, phone right)
                // next's gap-facing side is its RIGHT → subtract paddingRight
                // prev's gap-facing side is its LEFT → add paddingLeft
                const nextTextRight = nextRect.right - (parseFloat(nextStyle.paddingRight) || 0)
                const prevTextLeft = prevRect.left + (parseFloat(prevStyle.paddingLeft) || 0)
                gapMidX = (nextTextRight + prevTextLeft) / 2
              } else {
                // prev is to the left of next
                const prevTextRight = prevRect.right - (parseFloat(prevStyle.paddingRight) || 0)
                const nextTextLeft = nextRect.left + (parseFloat(nextStyle.paddingLeft) || 0)
                gapMidX = (prevTextRight + nextTextLeft) / 2
              }
              const separatorX = gapMidX - containerRect.left
              ctx.fillStyle = 'white'
              ctx.fillRect(separatorX - 1, fy + fh * 0.15, 2, fh * 0.7)
            }
            continue
          }

          if (childStyle.display === 'none') continue

          const childRect = child.getBoundingClientRect()
          const cx = childRect.left - containerRect.left
          const cy = childRect.top - containerRect.top

          if (child.tagName === 'IMG') {
            try {
              const logoImg = await this.loadImageForCanvas(child.src)
              ctx.drawImage(logoImg, cx, cy, childRect.width, childRect.height)
            } catch (e) { /* logo optional */ }
          } else if (child.tagName === 'P') {
            const text = child.textContent.trim()
            if (!text) continue
            ctx.fillStyle = childStyle.color
            ctx.font = childStyle.fontStyle + ' ' + childStyle.fontWeight + ' ' + childStyle.fontSize + ' ' + childStyle.fontFamily
            ctx.textBaseline = 'middle'
            ctx.direction = 'rtl'

            if (child.classList.contains('logo_tagline')) {
              // Tagline has ::before and ::after pseudo-elements (decorative lines)
              const beforeStyle = window.getComputedStyle(child, '::before')
              const afterStyle = window.getComputedStyle(child, '::after')
              const gap = parseFloat(childStyle.gap) || parseFloat(childStyle.columnGap) || 15
              const padRight = parseFloat(childStyle.paddingRight) || 0
              const padLeft = parseFloat(childStyle.paddingLeft) || 0

              let bw = 0; let bh = 0; let aw = 0; let ah = 0
              const hasBefore = beforeStyle.display !== 'none' && parseFloat(beforeStyle.width) > 0
              const hasAfter = afterStyle.display !== 'none' && parseFloat(afterStyle.width) > 0

              if (hasBefore) {
                bw = parseFloat(beforeStyle.width)
                bh = parseFloat(beforeStyle.height)
              }
              if (hasAfter) {
                aw = parseFloat(afterStyle.width)
                ah = parseFloat(afterStyle.height)
              }

              // In RTL inline-flex: right-to-left order is ::before | gap | TEXT | gap | ::after
              // Account for padding and pseudo-element offset
              const rightOffset = padRight + (hasBefore ? bw + gap : 0)
              ctx.textAlign = 'start'
              ctx.fillText(text, cx + childRect.width - rightOffset, cy + childRect.height / 2)

              // Draw ::before (rightmost in RTL), inside padding
              if (hasBefore && bw > 0 && bh > 0) {
                ctx.fillStyle = beforeStyle.backgroundColor || 'white'
                ctx.fillRect(cx + childRect.width - padRight - bw, cy + (childRect.height - bh) / 2, bw, bh)
              }
              // Draw ::after (leftmost in RTL), inside padding
              if (hasAfter && aw > 0 && ah > 0) {
                ctx.fillStyle = afterStyle.backgroundColor || 'white'
                ctx.fillRect(cx + padLeft, cy + (childRect.height - ah) / 2, aw, ah)
              }
            } else {
              // Phone or other text - no pseudo-elements
              ctx.textAlign = 'start'
              ctx.fillText(text, cx + childRect.width, cy + childRect.height / 2)
            }
          }
        }
      }

      return canvas
    },
    async downloadImage () {
      if (!this.selected_picture || !this.position) {
        if (this.$toast) {
          this.$toast.error('אין תמונה להורדה')
        }
        return
      }

      this.isGeneratingImage = true

      try {
        const canvas = await this.captureContentMaker()

        // Generate filename with timestamp
        const timestamp = new Date().toISOString().slice(0, 10).replace(/-/g, '_')
        const timeString = new Date().toTimeString().slice(0, 8).replace(/:/g, '_')
        const filename = `תמונה_${this.title.replace(/\s+/g, '_')}_${timestamp}_${timeString}.jpg`

        // Convert canvas to JPEG blob
        const jpegBlob = await new Promise(resolve => {
          canvas.toBlob(resolve, 'image/jpeg', 0.9) // 0.9 quality for good balance between size and quality
        })

        // Try to save image to server, but always download locally
        let serverSaveSuccess = false
        try {
          await this.saveImageToServer(jpegBlob, filename)
          serverSaveSuccess = true
        } catch (error) {
          console.warn('Server save failed, continuing with local download:', error)
        }

        // Always download locally
        const downloadLink = document.createElement('a')
        downloadLink.href = URL.createObjectURL(jpegBlob)
        downloadLink.download = filename
        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)
        URL.revokeObjectURL(downloadLink.href)

        // Show appropriate message based on server save result
        if (serverSaveSuccess) {
          this.$toast.success('תמונה נשמרה והורדה בהצלחה')
        } else {
          this.$toast.success('תמונה הורדה בהצלחה (לא נשמרה בשרת)')
        }
      } catch (error) {
        console.error('Error generating image:', error)
        this.$toast.error('שגיאה ביצירת התמונה')
      } finally {
        this.isGeneratingImage = false
      }
    },
    async saveImageToServer (jpegBlob, filename) {
      // Create FormData
      const formData = new FormData()
      formData.append('image', jpegBlob, filename)

      // Send to rebase server using network_utils
      await this.$network_utils.postPositionPostImage({
        position_id: this.position.id,
        form_data: formData
      })
    }
  },
  components: {
    Checkbox,
    ImageGenerator,
    SuitupFooter,
    OfficeFooter,
    RebaseFooter,
    PiolaFooter
  }
}
</script>
<style scoped>
  .editor {
    width: 50%;
  }
  .left_column {
    width: 50%;
    border-right: 1px solid rgba(0, 0, 0, 0.1);
    margin-right: 10px;
    padding-right: 30px;
  }
  .content_maker_container {
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    margin-top: 10px;
    padding-top: 10px;
  }
  #content_maker {
    overflow: hidden;
    position: relative;
    font-family: APP_FONT;
    margin-top: 20px;
    width: 840px;
    height: 626px;
  }
  .content_maker_image {
    display: block;
    object-fit: cover;
    height: 100%;
    width: 100%;
    max-height: 100%;
  }
  .content_maker_stars {
    position: absolute;
    pointer-events: none;
    z-index: 1000;
    opacity: 0.51;
    object-fit: cover;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
  }
  .content_maker_opacity {
    position: absolute;
    z-index: 10;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
  }

  /* Editable Text Overlays */
  .editable-text-overlay {
    position: absolute;
    outline: none;
    padding: 10px;
    z-index: 10000;
    font-family: APP_FONT;
    color: white;
    border: none;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 5px;
    cursor: text;
    min-height: 40px;
    word-wrap: break-word;
    white-space: pre-wrap;
  }

  .editable-text-overlay:hover {
    background: rgba(0, 0, 0, 0.5);
  }

  .editable-text-overlay:focus {
    background: rgba(0, 0, 0, 0.6);
    box-shadow: 0 0 5px rgba(255, 255, 255, 0.5);
  }

  .editable-text-overlay:empty:before {
    content: attr(data-placeholder);
    color: rgba(255, 255, 255, 0.6);
    font-style: italic;
  }

  /* Positioning for different text elements */
  .title-text {
    top: 20px;
    left: 20px;
    right: 20px;
    font-size: 32px;
    font-weight: bold;
    text-align: center;
  }

  .description-text {
    top: 100px;
    left: 20px;
    right: 20px;
    font-size: 18px;
    max-height: 150px;
    overflow-y: auto;
  }

  .work-entails-text {
    top: 280px;
    left: 20px;
    right: 20px;
    font-size: 16px;
    max-height: 100px;
    overflow-y: auto;
  }

  .requirements-text {
    top: 400px;
    left: 20px;
    right: 20px;
    font-size: 16px;
    max-height: 80px;
    overflow-y: auto;
  }

  .hashtags-text {
    top: 500px;
    left: 20px;
    right: 20px;
    font-size: 14px;
    color: #87CEEB;
    max-height: 60px;
    overflow-y: auto;
  }

  .content_maker_input {
    position: absolute;
    outline: none;
    padding-bottom: 20px;
    z-index: 10000;
    font-family: APP_FONT;
    width: 100%;
    padding-right: 10px;
    padding-left: 10px;
    line-height: 5rem;
    width: 100%;
    max-height: 80%;
    font-size: 68px;
    text-align: center;
    color: white;
    border: none;
    background: transparent;
    z-index: 10000;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .unified_content {
    z-index: 10000;
    line-height: 5rem;
    width: calc(100% - 100px);
    text-align: center;
    font-size: 82px;
    color: white;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .unified_content p {
    margin: 0;
    padding: 5px;
    white-space: pre-wrap;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  .preview_text_container {
    font-size: 14px;
    margin-top: 0;
    position: sticky;
    top: 0;
  }
  .preview_text_container p {
    display: block;
    margin: 0;
    margin-bottom: 20px;
  }
  .margin_top_0{
    margin-top: 0 !important;
  }
  .margin_bottom_0{
    margin-bottom: 0 !important;
  }
  .content_maker_logo_container {
    color: white;
    overflow: hidden;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0 20px;
    height: 100%;
    z-index: 1000000;
    background-color: rgba(91, 75, 75, 0.8);
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 70px;
  }
  .content_maker_logo_container_rebase {
    z-index: 10000000;
    position: absolute;
    display: flex;
    justify-content: center;
    left: 0;
    right: 0;
    bottom: 10px;
    height: 75px;
  }
  .content_maker_logo_container_office {
    background-color: rgba(35, 6, 69, 0.8)
  }
  .instagram_frame_image {
    width: 700px;
    height: 700px;
    object-fit: cover;
    position: absolute;
  }
  .logo_tagline{
    margin: 0;
    padding: 0 15px;
    font-variant-ligatures: none;
    white-space: nowrap;
    text-align: center;
    font-size: 34px;
    font-weight: 500;
    line-height: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
  }

  .logo_tagline::before {
    content: '';
    width: 2px;
    height: 55px;
    background-color: white;
    flex-shrink: 0;
  }

  .logo_tagline::after {
    content: '';
    width: 20px;
    height: 2px;
    background-color: white;
    flex-shrink: 0;
  }

  .footer_phone {
    margin: 0;
    padding: 0;
    text-align: right;
    font-size: 44px;
    font-weight: 600;
    line-height: 1;
    white-space: nowrap;
  }

  .content_maker_logo_container img {
    display: block;
  }

  .footer_divider {
    display: none;
  }

  [style*="gap: 0px"] > .footer_divider {
    display: block;
    width: 2px;
    align-self: center;
    height: 70%;
    background-color: white;
  }

  /* Piola-specific smaller separator lines */
  .logo_tagline_piola::before {
    width: 2px !important;
    height: 35px !important;
  }

  .logo_tagline_piola::after {
    width: 15px !important;
    height: 2px !important;
  }

  /* Rebase-specific: Remove separator lines, use dot instead */
  .content_maker_logo_container .logo_tagline::before {
    content: '';
  }

  .content_maker_logo_container .logo_tagline::after {
    content: '';
  }

  /* Hide dividers for Rebase by targeting the parent container style */
  [style*="gap: 0px"] .logo_tagline::before,
  [style*="gap: 0px"] .logo_tagline::after {
    display: none !important;
  }

  /* Rebase Custom Template Styles */
  p {
    margin: 0;
  }

  @font-face {
    src: url("/content_maker/rebase/font.ttf");
    font-family: "MAIN_FONT";
  }

  .bold {
    font-weight: 400;
  }

  body {
    margin: 0;
    padding: 0;
    font-family: MAIN_FONT;
  }

  .container {
    position: absolute;
    width: 840px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 626px;
    margin-top: 20px;
    font-family: MAIN_FONT;
  }

  .opacity {
    position: absolute;
    z-index: 10;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
  }

  .content {
    z-index: 10000;
    line-height: 5rem;
    width: calc(100% - 100px);
    text-align: center;
    font-size: 82px;
    color: white;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .background_image {
    position: absolute;
    height: 100%;
    object-fit: cover;
  }

  .slogan {
    font-size: 14px;
    margin-left: 10px;
    color: white;
    text-align: center;
    display: inline-block;
  }

  .slogan_container {
    display: flex;
    align-items: flex-end;
    height: 30px;
  }

  .logo {
    position: relative;
    display: block;
    left: -50%;
    transform: translateX(50%);
  }

  .logo_container {
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    z-index: 1000000;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 80px;
  }

  .stars {
    z-index: 100;
    opacity: 0.51;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    object-fit: cover;
  }

  /* Saved Images Styles */
  .saved-images-section {
    border-top: 1px solid #ddd;
    padding-top: 15px;
    margin-top: 15px;
  }

  .saved-images-section h4 {
    margin-bottom: 10px;
    font-weight: bold;
  }

  .loading, .no-images {
    text-align: center;
    color: #666;
    padding: 20px;
  }

  .saved-images-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 15px;
    margin-top: 10px;
  }

  .saved-image-item {
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 10px;
    text-align: center;
    background: #f9f9f9;
  }

  .saved-image-thumbnail {
    width: 100%;
    height: 100px;
    object-fit: cover;
    border-radius: 4px;
    cursor: pointer;
    margin-bottom: 8px;
  }

  .saved-image-thumbnail:hover {
    opacity: 0.8;
  }

  .saved-image-actions {
    display: flex;
    gap: 5px;
    justify-content: center;
    margin-bottom: 5px;
  }

  .saved-image-filename {
    font-size: 11px;
    color: #666;
    word-break: break-all;
  }

  /* Fix double arrow in select dropdown - remove Bulma's custom arrow */
  .select::after {
    display: none !important;
  }
</style>
